import React from 'react';

interface MediaProps {
    imageUrl: string;
    videoUrl?: string; // Optional field if your model allows it
    title: string;
    displayMode?: string; // e.g., "video", "image"
}

const MediaDisplay: React.FC<MediaProps> = ({ imageUrl, title, displayMode = 'image' }) => {
    if (displayMode === "video" && imageUrl) {
        return (
            <video controls autoPlay={true} loop muted className="product-media">
                <source src={imageUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    }
    return <img src={imageUrl} alt={title} className="product-media" />;
};

export default MediaDisplay;